var miniCart = require('./components/miniCart');
var processInclude = require('base/util');

// eslint-disable-next-line no-undef
$(document).ready(function () {
    processInclude(miniCart);
});
